// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 767px) {\n.advanced-filters__wrapper.advanced-filters__wrapper {\n    top: 45px;\n    bottom: 50px;\n    width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
